module.exports = __webpack_public_path__ + "static/media/ios-menu.da93b3c4.svg";